import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import "./AboutMe.css";
import profileImg from "../../assets/Home/profilephoto.png";
import me from "../../assets/AboutMe/youtube.png"

export default function AboutMe(props) {

  const SCREEN_CONSTSANTS = {
    description:
      `Acharya Arun Pandey has attained more then 10 years of experience in vedic Astrology & Vastu Shastra. He provides accurate remedies along with some valuable advise and has a very good understanding when it comes to offering prediction releted to health, marriage, education, career, money & finance, marriage matching, muhurat & Vastu Shastra. 
      He has completed the Jyotish Acharya course from Viswa Jyotish Vidyapith. To date, he has successful list of client base to his credit. He is very well acquainted with all the intericacies astrology and hopes to proviide the best of his services to people. You can Follow him on YouTube channel '@TruthofAstroLife' for enriching discussions and valuable insights into various Vastu related topics.
      `,
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
<div data-aos="zoom-in" data-aos-delay={400} className="about-me-container screen-container" id={props.id || ""}>
  <div className="about-me-parent">
    <ScreenHeading title={"Get to Know Me"} />

    <div className="about-layout">
      <div style={{ flex: 1, position:"relative"}}>
        <svg id="bg-services" width="85%" viewBox="0 0 1000 800">
          <defs>
            <linearGradient id="PSgrad_02" x1="64.279%" x2="0%" y1="76.604%" y2="0%">
              <stop offset="0%" stop-color="rgb(83.9, 20, 0)" stop-opacity="1" />
              <stop offset="100%" stop-color="rgb(21.6, 5.1, 0)" stop-opacity="1" />
            </linearGradient>
          </defs>
          <path fill-rule="evenodd" opacity="0.102" fill="url(#PSgrad_02)"
            d="M801.878,3.146 L116.381,128.537 C26.052,145.060 -21.235,229.535 9.856,312.073 L159.806,710.157 C184.515,775.753 264.901,810.334 338.020,792.380 L907.021,652.668 C972.912,636.489 1019.383,573.766 1011.301,510.470 L962.013,124.412 C951.950,45.594 881.254,-11.373 801.878,3.146 Z" />
        </svg>
        <img className="profile-img" src={profileImg} alt="Profile" />
      </div>

      <div className="about-me-card" style={{ flex: 2 }}>
        <div className="about-me-details">
          <div className="about-me-description">
            With over <b>10 years of experience</b> in <b>Vedic Astrology and Vastu Consultancy</b>, I have dedicated my life to
            understanding and interpreting the cosmic patterns that shape our lives. I specialize in offering accurate and insightful
            predictions related to <b>health, marriage, education, career, money & finance, marriage matching, muhurat selection, and
              Vastu Shastra</b>.
          </div>
          <div className="about-me-description" style={{ marginTop: "15px" }}>
            I earned the title of Jyotish Acharya from Central Sanskrit University (Delhi), grounding my practice in deep knowledge and
            expertise. Over the years, I have been fortunate to connect with people through YouTube and other platforms, where my work has
            received widespread appreciation and positive feedback.
          </div>
          <div className="about-me-description" style={{ marginTop: "15px" }}>
            My goal is to guide individuals toward clarity and harmony by blending ancient wisdom with practical solutions. Whether you're
            seeking guidance for your future, a favorable muhurat, or balanced Vastu solutions, I'm here to assist you every step of the
            way.
          </div>
          <div className="about-me-description" style={{ marginTop: "20px", marginBottom: "20px"}}>
            <b style={{ color: "brown" }}>Check out our YouTube channel! Click the link below to explore and subscribe.</b>
          </div>
        </div>
      </div>
    </div>

    <div style={{ display: "flex", justifyContent: "center" }}>
      <a href="https://www.youtube.com/channel/UCb4ZDcIPonAzG9G2Lrw_Syg" target="_blank" rel="noopener noreferrer">
        <img src={me} alt="Visit our YouTube channel" style={{
          border: "1px solid lightgray",
          borderRadius: "20px",
          boxShadow: "7px 7px 7px lightgray",
          width: "90%",
          maxWidth: "500px"
        }} />
      </a>
    </div>
    <div style={{textAlign: "center", marginTop: "20px"}}>
      <a href="https://www.youtube.com/channel/UCb4ZDcIPonAzG9G2Lrw_Syg" target="_blank" rel="noopener noreferrer">
        <button style={{
          background: "brown",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer"
        }}>
          👉 Subscribe on YouTube
        </button>
      </a>
    </div>
  </div>
</div>
  );
}
